<div class="modal-header">
  <h5 class="modal-title" i18n="@@CreateDeliveryCSVHeader">CSV generieren</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <app-create-delivery-csv [transactions]="transactions" [userId]="userId" [customerId]="customerId" #createDeliveryCSVComponent></app-create-delivery-csv>
</div>

<div class="modal-footer">
  <a class="btn btn-yellow me-2" id="cancel" data-bs-toggle="modal" role="button" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</a>
  <form [formGroup]="formService.form">
    <button type="button" id="create_deliverycsv_and_download" class="btn btn-save" 
            [disabled]="!formService.form.valid" 
            (click)="createDeliveryCSVComponent.onSubmit(formService.form.value, true)" 
            i18n="@@CreateDeliveryCSVButton">Speichern
    </button>
  </form>
</div>
